import LocationAndDateSelectWrapper from './LocationAndDateSelectWrapper';

export default LocationAndDateSelectWrapper;
